import {useEffect, useState} from 'react';
import {Button, Input, Typography, Alert} from 'antd';
import DBModal from 'components/modal/modal';
import {KYB_ACTION_COPY} from '../kybConstants';
import {isReasonRequired} from '../kybUtils';
import styles from '../kybDashboard.module.scss';

const {Text} = Typography;

/**
 * Move the whole submission through the lifecycle.
 *
 * `reason` is required on `REJECTED` and `MORE_INFO` and is emailed to the
 * business verbatim, so the field is validated here and labelled as customer
 * copy rather than as an internal note.
 */
export const SetKybStatusModal = ({
  open,
  status,
  onClose,
  onSubmit,
  submitting,
}) => {
  const [reason, setReason] = useState('');
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    if (open) {
      setReason('');
      setTouched(false);
    }
  }, [open, status]);

  const copy = KYB_ACTION_COPY[status] || {};
  const reasonRequired = isReasonRequired(status);
  const reasonMissing = reasonRequired && !reason.trim();

  const handleSubmit = () => {
    setTouched(true);
    if (reasonMissing) return;
    onSubmit({status, ...(reason.trim() && {reason: reason.trim()})});
  };

  return (
    <DBModal
      isOpen={open}
      handleClose={onClose}
      width={520}
      destroyOnClose
      content={
        <div className={styles.modalBody}>
          <h2 className={styles.modalTitle}>{copy.title}</h2>
          <Text type="secondary">{copy.description}</Text>

          {reasonRequired && (
            <div className={styles.modalField}>
              <label className={styles.fieldLabel}>
                Reason (required, sent to the business)
              </label>
              <Input.TextArea
                rows={4}
                value={reason}
                maxLength={1000}
                showCount
                placeholder="We need a certificate of good standing issued in the last 3 months."
                onChange={event => setReason(event.target.value)}
              />
              <Text type="secondary" className={styles.fieldHint}>
                This is emailed to the business word for word and shown in their
                app. Write it as customer-facing copy, not an internal note.
              </Text>
              {touched && reasonMissing && (
                <Text type="danger" className={styles.fieldError}>
                  A reason is required for this decision.
                </Text>
              )}
            </div>
          )}

          {status === 'APPROVED' && (
            <Alert
              type="warning"
              showIcon
              className={styles.modalField}
              message="Approving is final — there is no un-approve operation."
            />
          )}

          <div className={styles.modalActions}>
            <Button onClick={onClose}>Cancel</Button>
            <Button
              type="primary"
              loading={submitting}
              danger={status === 'REJECTED'}
              onClick={handleSubmit}>
              {copy.confirm}
            </Button>
          </div>
        </div>
      }
    />
  );
};
